export default "__VITE_ASSET__CvZ0aueF__"